import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import store from "../../store";
import { Loader } from "../../components/loader";
import { createRegType, updateDefault,fetchRegTypes, getEditable } from "../../actions/regType";
import { forceInputUppercase } from "../../utils/helper";


import moment from 'moment';
const $ = window.$;
class AddRegType extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        regType: "",
        loading: false,
        inputNotValid: false,
        RegTypeId: null,
      };
    }
    handleChange = event => {
      forceInputUppercase(event);
      const value = event.target.value;
      this.setState({
        ...this.state,
        [event.target.name]: value
      });
    };
 
    submit(e) {
      e.preventDefault();
      this.setState({ loading: true });
      let data = {    
          type: this.state.regType,
          PetShopId: this.props.petShop.currentPetshop.id,
        };
        let valid = this.state.regType.length > 0;
        if (valid) {
          if(this.state.RegTypeId){
            data.id = this.state.RegTypeId;           
            this.props.getEditable(data);     
          }else{
            this.props.createRegType(data);
          }      
        } else {
          e.preventDefault();
          NotificationManager.warning("Registration type cannot be empty");
          this.setState({ loading: false , inputNotValid: true });
        }
    }

    resetState = () => {
      this.setState({
        regType: "",
        loading: false,
        inputNotValid: false,
        RegTypeId : null
      });
    };
    closeModal = () => {
      $("#add_reg_type").modal("hide");
      this.resetState();
    };
  
    componentWillReceiveProps = nextProps => {
      if (nextProps.selectedRegTypeData 
        && nextProps.selectedRegTypeData.id
        && nextProps.selectedRegTypeData.id !== this.state.RegTypeId && nextProps.selectedRegTypeData !== this.props.selectedRegTypeData ) {   
        this.setState({
          RegTypeId : nextProps.selectedRegTypeData.id,
          regType : nextProps.selectedRegTypeData.type,        
          }, () => {               
            $("#add_reg_type").modal("show");            
         });
      }

      if (nextProps.regType && this.props.regType !== nextProps.regType) {
        const regTypeExistWithSameName = '210';  
        switch(nextProps.regType){
          case regTypeExistWithSameName:
            NotificationManager.error("Registration Type exists");
            this.setState({ regType: "", RegTypeId : null, loading: false });
            $("#add_reg_type").modal("hide"); 
            break;
          default : 
            NotificationManager.success("Registration Type Added");
            this.setState({ regType: "", RegTypeId : null, loading: false });
            $("#add_reg_type").modal("hide");
        }    
      }

      if (nextProps.regTypeError && this.props.regTypeError !== nextProps.regTypeError) {
        this.setState({ regType: "", loading: false });
        if(nextProps.regTypeError.message && nextProps.regTypeError.message.name === 'SequelizeUniqueConstraintError') {
          NotificationManager.error("Registration type already exists");
        } else {
          NotificationManager.error("Failed to add Registration Type.");
        }
        
        $("#add_reg_type").modal("hide");
      }

      if (nextProps.updateRegType && this.props.updateRegType  !== nextProps.updateRegType) {
        this.setState({  regType: "", RegTypeId :null, loading: false });
        NotificationManager.success("Registration Type Updated");
        this.props.fetchRegTypes();
        $("#add_reg_type").modal("hide");
      }   

      if (nextProps.updateRegTypeError && this.props.updateRegTypeError !== nextProps.updateRegTypeError) {
        const regTypeExist = "Registration type already exists";
        this.setState({  regType: "", RegTypeId :null, loading: false });      
        if (nextProps.updateRegTypeError.message === regTypeExist)
          NotificationManager.error("Registration type already exists");
        else
          NotificationManager.error("Registration type update fail.");
        $("#add_reg_type").modal("hide");
      } 


    };
  
    render() {
      return (
        <div
        className="modal fade show"
        id="add_reg_type"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <form className="m-form">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">               
                  {!this.state.RegTypeId  ? "New Registration Type" : "Edit Registration Type"}
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="m-form__section m-form__section--first">
                      {/* <div className="m-form__heading">
                                    <h3 className="m-form__heading-title">User Details</h3>
                                </div> */}

                      <div className="form-group m-form__group row">
                        <label className="col-xl-3 col-lg-3 col-form-label">
                          Registration Type:
                        </label>
                        <div className="col-xl-9 col-lg-9">
                          <input
                            type="text"
                            name="regType"
                            value={this.state.regType}
                            className="form-control m-input"
                            placeholder=""
                            onChange={e => this.handleChange(e)}
                          />
                          <span
                            className={
                              this.state.inputNotValid
                                ? "m-form__help_danger"
                                : "m-form__help"
                            }
                          >
                            Please enter registration type
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {this.state.loading == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      onClick={this.closeModal}
                    >
                      Close
                    </button>
                    <button
                      onClick={e => this.submit(e)}
                      type="submit"
                      className="btn btn-primary m-btn--pill"
                    >
                      Submit
                    </button>
                  </div>
                ) : (
                  <div className="center-row">
                    <Loader size={50} />
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
     
      );
    }
  }
  
  const mapStateToProps = state => ({
    petShop: state.petShopReducer,
    regType: state.regTypeReducer.setRegType,
    regTypeError: state.regTypeReducer.setRegTypeError,
    updateRegType: state.regTypeReducer.updateRegType,
    updateRegTypeError : state.regTypeReducer.updateRegTypeError,
    selectedToDeleteError : state.regTypeReducer.selectedToDeleteError,

  });

  
  const mapDispatchToProps = dispatch => ({
    createRegType: pet => {
      dispatch(createRegType(pet));
    },
    getEditable: data => {
      dispatch(getEditable(data));
    },
    fetchRegTypes: () => {
      dispatch(fetchRegTypes());
    },
  });
  
  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(AddRegType)
  );